// extracted by mini-css-extract-plugin
export var contentWrapperStyle = "how_it_works-module--contentWrapperStyle--g6A6V";
export var copyWrapperStyle = "how_it_works-module--copyWrapperStyle--BaRXp";
export var featureWrapperStyle = "how_it_works-module--featureWrapperStyle--R-1O5";
export var headingWrapperStyle = "how_it_works-module--headingWrapperStyle--0Fyn0";
export var isReversedStyle = "how_it_works-module--isReversedStyle--4hEGc";